import { Box, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { formatTime } from './layout'

const MIN_BLOCK_PX = 20
const STACKED_PX = 38

const typeLabel = (type, t) =>
  type === 'course-session' ? t('Course Session') : type === 'break' ? t('Break') : t('Lunch')

export default function PeriodColumn({ periods, pxPerHour, height, compactText, column, row }) {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        gridColumn: column,
        gridRow: row,
        position: 'relative',
        height,
        borderRight: '1px solid',
        borderColor: 'divider',
      }}
    >
      {periods.map(block => {
        const { key, start, end, topHours, heightHours, lane, laneCount } = block
        const blockHeight = Math.max(MIN_BLOCK_PX, heightHours * pxPerHour)
        const stacked = blockHeight >= STACKED_PX
        const names = block.periods.map(p => p.name || typeLabel(p.type, t))
        const label = names.join(' · ')
        const time = `${formatTime(start)} – ${formatTime(end)}`

        return (
          <Tooltip key={key} title={`${label} · ${time}`} placement="right" arrow>
            <Box
              sx={{
                position: 'absolute',
                top: topHours * pxPerHour,
                height: blockHeight,
                left: `calc(${(lane / laneCount) * 100}% + 4px)`,
                width: `calc(${(1 / laneCount) * 100}% - 10px)`,
                px: 0.75,
                py: 0.25,
                borderRadius: 1,
                bgcolor: 'action.hover',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                overflow: 'hidden',
              }}
            >
              <Typography
                sx={{
                  fontSize: compactText ? 9 : 11,
                  lineHeight: 1.2,
                  fontWeight: 600,
                  color: 'text.primary',
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: stacked ? 2 : 1,
                  overflow: 'hidden',
                  overflowWrap: 'anywhere',
                }}
              >
                {label}
              </Typography>
              {stacked && (
                <Typography
                  noWrap
                  sx={{
                    fontSize: compactText ? 8 : 10,
                    lineHeight: 1.2,
                    color: 'text.secondary',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {time}
                </Typography>
              )}
            </Box>
          </Tooltip>
        )
      })}
    </Box>
  )
}
